(function () {
	if (window.cartUpsellBarInitialized) {
		return;
	}

	window.cartUpsellBarInitialized = true;

	function formatMoney(cents) {
		var formatString = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat ? window.themeVariables.settings.moneyFormat : "{{amount}}";
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var match = formatString.match(placeholderRegex);
		var placeholder = match ? match[1] : "amount";
		var value = "";

		if (typeof cents === "string") {
			cents = cents.replace(".", "");
		}

		cents = Number(cents || 0);

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = precision == null ? 2 : precision;
			thousands = thousands == null ? "," : thousands;
			decimal = decimal == null ? "." : decimal;

			if (isNaN(number) || number == null) {
				return "0";
			}

			var parts = (number / 100).toFixed(precision).split(".");
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
			var centsAmount = parts[1] ? decimal + parts[1] : "";

			return dollarsAmount + centsAmount;
		}

		switch (placeholder) {
			case "amount":
				value = formatWithDelimiters(cents, 2);
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0);
				break;
			case "amount_with_comma_separator":
				value = formatWithDelimiters(cents, 2, ".", ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ".", ",");
				break;
			case "amount_with_space_separator":
				value = formatWithDelimiters(cents, 2, " ", ".");
				break;
			case "amount_no_decimals_with_space_separator":
				value = formatWithDelimiters(cents, 0, " ");
				break;
			case "amount_with_apostrophe_separator":
				value = formatWithDelimiters(cents, 2, "'", ".");
				break;
			case "amount_no_decimals_with_apostrophe_separator":
				value = formatWithDelimiters(cents, 0, "'", ".");
				break;
			default:
				value = formatWithDelimiters(cents, 2);
		}

		return formatString.replace(placeholderRegex, value);
	}

	function updateCardFromSelect(select) {
		var card = select.closest("[data-cart-upsell-card]");
		var option = select.options[select.selectedIndex];
		var button = card && card.querySelector("[data-cart-upsell-add]");
		var price = card && card.querySelector("[data-cart-upsell-price]");
		var comparePrice = card && card.querySelector("[data-cart-upsell-compare-price]");
		var image = card && card.querySelector("[data-cart-upsell-image]");
		var variantId = option ? option.value : "";
		var priceValue = option ? Number(option.getAttribute("data-price") || 0) : 0;
		var comparePriceValue = option ? Number(option.getAttribute("data-compare-price") || 0) : 0;
		var imageSrc = option ? option.getAttribute("data-image-src") : "";
		var imageSrcset = option ? option.getAttribute("data-image-srcset") : "";
		var imageAlt = option ? option.getAttribute("data-image-alt") : "";

		if (!card || !button) {
			return;
		}

		button.setAttribute("data-variant-id", variantId);
		button.disabled = !variantId;

		if (price && priceValue > 0) {
			price.textContent = formatMoney(priceValue);
		}

		if (comparePrice) {
			if (comparePriceValue > priceValue) {
				comparePrice.textContent = formatMoney(comparePriceValue);
				comparePrice.hidden = false;
			} else {
				comparePrice.textContent = "";
				comparePrice.hidden = true;
			}
		}

		if (image && imageSrc) {
			image.src = imageSrc;

			if (imageSrcset) {
				image.srcset = imageSrcset;
			} else {
				image.removeAttribute("srcset");
			}

			if (imageAlt) {
				image.alt = imageAlt;
			}
		}
	}

	function scrollUpsell(scroller, direction) {
		if (!scroller) {
			return;
		}

		var firstCard = scroller.querySelector("[data-cart-upsell-card]");
		var scrollAmount = firstCard ? firstCard.offsetWidth + 10 : Math.round(scroller.clientWidth * 0.8);

		scroller.scrollBy({
			left: direction === "next" ? scrollAmount : -scrollAmount,
			behavior: "smooth",
		});
	}

	async function refreshCartDrawer(addResponseJson) {
		var cartResponse = await fetch(window.themeVariables.routes.cartUrl + ".js", {
			credentials: "same-origin",
		});
		var cartContent = await cartResponse.json();

		if (addResponseJson && addResponseJson.sections) {
			cartContent.sections = addResponseJson.sections;
		}

		document.documentElement.dispatchEvent(
			new CustomEvent("cart:updated", {
				bubbles: true,
				detail: {
					cart: cartContent,
				},
			}),
		);

		document.documentElement.dispatchEvent(
			new CustomEvent("cart:refresh", {
				bubbles: true,
				detail: {
					cart: cartContent,
					openMiniCart: true,
				},
			}),
		);
	}

	async function addUpsell(button) {
		var variantId = button.getAttribute("data-variant-id");
		var buttonText = button.querySelector("[data-cart-upsell-button-text]");
		var spinner = button.querySelector(".cart-upsell-bar__spinner");

		if (!variantId || button.disabled) {
			return;
		}

		button.disabled = true;
		button.setAttribute("aria-busy", "true");

		if (buttonText) {
			buttonText.hidden = true;
		}

		if (spinner) {
			spinner.hidden = false;
		}

		try {
			var response = await fetch(window.themeVariables.routes.cartAddUrl + ".js", {
				method: "POST",
				credentials: "same-origin",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					items: [
						{
							id: Number(variantId),
							quantity: 1,
						},
					],
					sections: ["mini-cart"],
				}),
			});
			var responseJson = await response.json();

			if (!response.ok) {
				throw responseJson;
			}

			await refreshCartDrawer(responseJson);
		} catch (error) {
			console.error("Cart upsell add failed:", error);
			button.disabled = false;
			button.removeAttribute("aria-busy");

			if (buttonText) {
				buttonText.hidden = false;
			}

			if (spinner) {
				spinner.hidden = true;
			}
		}
	}

	document.addEventListener("change", function (event) {
		var select = event.target.closest("[data-cart-upsell-variant]");

		if (select) {
			updateCardFromSelect(select);
		}
	});

	document.addEventListener("click", function (event) {
		var button = event.target.closest("[data-cart-upsell-add]");
		var scrollButton = event.target.closest("[data-cart-upsell-scroll]");

		if (button) {
			event.preventDefault();
			addUpsell(button);
			return;
		}

		if (scrollButton) {
			event.preventDefault();
			scrollUpsell(scrollButton.closest("[data-cart-upsell-bar]") && scrollButton.closest("[data-cart-upsell-bar]").querySelector("[data-cart-upsell-scroller]"), scrollButton.getAttribute("data-cart-upsell-scroll"));
		}
	});
})();
